// This file was auto generated by resource-sync tools.

import en_tjt_operation_web from './en/tjt_operation_web.json';
import zh_tjt_operation_web from './zh/tjt_operation_web.json';

const resources = {
  namespaces: [
    {
      localeInfos: [
        { locale: 'en', version: 12 },
        { locale: 'zh', version: 13 },
      ],
      i18nConfig: { apiKey: 'c4772cfe702b4ae58f8393bd421469d8', projectId: 49, namespaceId: 'hr07v4bzi2', namespaceName: 'tjt_operation_web' },
    },
  ],
  en: {
    tjt_operation_web: en_tjt_operation_web,
  },
  zh: {
    tjt_operation_web: zh_tjt_operation_web,
  },
};

export default resources;
